import React, { useState } from 'react';
import type { Event } from '@/types/event';
import ModalHeader from './ModalHeader';
import ModalContent from './ModalContent';
import { Modal } from '../basic/Modal';

interface EventModalProps {
  event: Event;
  onClose: () => void;
  onRegister: (event: Event) => void;
  isRegistered: boolean;
  quota?: any;
}

const EventModal: React.FC<EventModalProps> = ({ event, onClose, onRegister, isRegistered = false, quota: myQuotas = {} }) => {
  const handleReserve = () => {
    onRegister(event);
  };

  return (
    <>
      <Modal onClose={onClose} size="sm">
        <div className="p-2 sm:p-4">
          <ModalHeader event={event} onClose={onClose} />
          <ModalContent event={event} onReserve={handleReserve} isRegistered={isRegistered} quota={myQuotas} onClose={onClose} />
        </div>
      </Modal>
    </>
  );
};

export default EventModal;